module.exports = ".bg-seen {\n    background: #F0FAFD !important;\n}\n"